export {
  BadRequest, NotAuthenticated, PaymentError, Forbidden, NotFound,
  MethodNotAcceptable, NotAcceptable, Timeout, Conflict,
  LengthRequired, Unprocessable, TooManyRequests,
  GeneralError, NotImplemented, BadGateway, Unavailable,
} from '@feathersjs/errors';
